import React from 'react'
import _ from 'lodash'

const ExtraPrivilegeMenu = ({
  extraPrivileges,
  voucherPrivileges,
  complimentaryPrivileges,
  onUseGuestPrivilegeClick,
  onClearExtraPrivilege,
  duration,
  guestOf,
}) => {
  const headerInfo = makePanelHeaderInfo(extraPrivileges, duration, guestOf)
  return (
    <div className="p-4">
      {/* Active Privilege Badge */}
      {headerInfo && (
        <div
          onClick={onClearExtraPrivilege}
          className="inline-flex items-center px-3 py-1.5 rounded-full bg-primary-100 text-primary-800 text-sm font-medium mb-4 cursor-pointer hover:bg-primary-200 transition-colors"
        >
          {headerInfo}
          <svg
            className="w-4 h-4 ml-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
      )}

      {/* Privilege Options */}
      <div className="space-y-2">
        {voucherPrivileges && renderVoucherPrivileges(voucherPrivileges)}
        {complimentaryPrivileges &&
          renderComplimentaryPrivileges(complimentaryPrivileges)}
        <button
          onClick={onUseGuestPrivilegeClick}
          className="w-full bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 px-4 rounded-lg transition-colors"
        >
          Guest Privilege
        </button>
      </div>
    </div>
  )
}

const renderVoucherPrivileges = (voucherPrivileges) =>
  voucherPrivileges.map(({ duration, useFn }) => (
    <button
      key={duration}
      onClick={useFn}
      className="w-full bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 px-4 rounded-lg transition-colors"
    >
      Voucher {duration && duration > 0 ? duration + ' hr.' : ''}
    </button>
  ))

const renderComplimentaryPrivileges = (complimentaryPrivileges) =>
  complimentaryPrivileges.map(({ duration, useFn }) => (
    <button
      key={duration}
      onClick={useFn}
      className="w-full bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 px-4 rounded-lg transition-colors"
    >
      Complimentary {duration && duration > 0 ? duration + ' hr.' : ''}
    </button>
  ))

const makePanelHeaderInfo = (extraPrivileges, duration, guestOf) => {
  return extraPrivileges
    ? makeExtraPrivilegeInfo(extraPrivileges, duration, guestOf)
    : undefined
}

const makeExtraPrivilegeInfo = (extraPrivileges, duration, guestOf) => {
  switch (extraPrivileges) {
    case 'guest':
      return `Guest of: ${_.get(guestOf, 'customerName', '-')}`
    case 'voucher':
      return 'Voucher' + (duration && duration > 0 ? `: ${duration} hr.` : '')
    case 'complimentary':
      return (
        'Complimentary' + (duration && duration > 0 ? `: ${duration} hr.` : '')
      )
    default:
      return '-'
  }
}

export default ExtraPrivilegeMenu
